import { render, staticRenderFns } from "./CompetencyDetail.vue?vue&type=template&id=d1243dd0&scoped=true&"
import script from "./CompetencyDetail.vue?vue&type=script&lang=js&"
export * from "./CompetencyDetail.vue?vue&type=script&lang=js&"
import style0 from "./CompetencyDetail.vue?vue&type=style&index=0&id=d1243dd0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1243dd0",
  null
  
)

export default component.exports